export const getCroppedImg = (imageSrc, cropArea) => {
   return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageSrc;
      image.onload = () => {
         const canvas = document.createElement('canvas');
         canvas.width = cropArea.width;
         canvas.height = cropArea.height;
         const ctx = canvas.getContext('2d');

         ctx.drawImage(
            image,
            cropArea.x,
            cropArea.y,
            cropArea.width,
            cropArea.height,
            0,
            0,
            cropArea.width,
            cropArea.height,
         );

         canvas.toBlob(blob => {
            if (!blob) {
               reject(new Error('Canvas is empty'));
               return;
            }
            resolve(blob);
         }, 'image/png');
      };

      image.onerror = () => reject(new Error('Failed to load image'));
   });
};
